var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-container"},[(!_vm.theme_switch)?_c('img',{attrs:{"src":_vm.$store.state.static_img_url + 'pic/quesheng-1.png'}}):_c('img',{attrs:{"src":_vm.$store.state.static_img_url + 'pic/quesheng-2.png'}}),_vm._t("p")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }